import { z } from 'zod';

export const messageFormDataSchema = z.object({
  message: z.string().trim().nullish(),
});

export type MessageFormData = z.infer<typeof messageFormDataSchema>;

export const messageFormDataDefault = {};
